import PropTypes from 'prop-types';
import { Navigate, useLocation } from 'react-router-dom';

import Loader from 'components/Loader';
import { useAuth } from 'contexts/AuthContext';

export default function AuthGuard({ children }) {
  const location = useLocation();
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <Loader />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return children;
}

AuthGuard.propTypes = {
  children: PropTypes.node.isRequired
};
